<template>
  <slot></slot>
</template>

<script>
import { useHead } from '@vueuse/head';
import { useRoute } from 'vue-router';
import { computed } from 'vue';

export default {
  name: 'GlobalHead',
  setup() {
    const route = useRoute();
    
    useHead(computed(() => {
      const isProtected = route.meta.isProtected;
      const path = route.path;
      
      const linkTags = [];
      if (!isProtected && path) {
        linkTags.push({ rel: 'canonical', href: `https://www.mywodhero.com${path}` });
      }

      return {
        title: route.meta.title || 'Wodhero',
        meta: [
          {
            name: 'description',
            content: route.meta.description || 'Wodhero is the modern platform for gym and CrossFit box management. Handle members, class booking, payments via Stripe, and much more.'
          },
          {
            name: 'robots',
            content: isProtected ? 'noindex, nofollow' : 'index, follow'
          }
        ],
        link: linkTags
      };
    }));
  }
}
</script>
